import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import * as yup from 'yup';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import firebase from '../../config/firebase';
// Reducers
import './ContactUsForm.css';

const INITIAL_STATE = {
  email: '',
  name: '',
  phone: '',
  message: '',
  mood: '',
  error: null,
  validationSchema: null,
  isSchemaLoaded: false,
};

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

export class ContactUsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    // Lazy load the validation schema
    this.loadValidationSchema();
  }

  loadValidationSchema = async () => {
    if (!this.state.isSchemaLoaded) {
      try {
        const { ContactSchema } = await import(
          '../../schemas/contactValidation'
        );
        this.setState({
          validationSchema: ContactSchema(),
          isSchemaLoaded: true,
        });
      } catch (error) {
        console.error('Failed to load validation schema:', error);
        // Fallback to a basic schema
        this.setState({
          validationSchema: yup.object().shape({
            message: yup.string().required('Required Field'),
          }),
          isSchemaLoaded: true,
        });
      }
    }
  };

  sendMessage(values) {
    console.log('Send message:', values);
    // const db = firebase.firestore();
    // const timestamp = new Date();
    // db.collection('contactus').add({
    //   created: timestamp,
    //   message: values.message,
    //   name: values.name,
    //   email: values.email,
    //   phone: values.phone,
    // });
  }

  render() {
    const {
      email,
      phone,
      error,
      name,
      message,
      mood,
      validationSchema,
      isSchemaLoaded,
    } = this.state;
    const isInvalid =
      phone === '' ||
      name === '' ||
      email === '' ||
      message === '' ||
      mood === '';

    // Show loading state while schema is loading
    if (!isSchemaLoaded) {
      return (
        <div id="signup">
          <div style={{ padding: '20px', textAlign: 'center' }}>
            Loading form...
          </div>
        </div>
      );
    }

    return (
      <div id="signup">
        <div>
          <Formik
            initialValues={{
              // name: '',
              // email: '',
              // phone: '',
              message: '',
              // mood: '',
            }}
            validationSchema={validationSchema}
            // validate={values => {
            //   let errors = {};
            //   if (!values.email) {
            //     errors.email = "Required";
            //   } else if (
            //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            //   ) {
            //     errors.email = "Invalid email address";
            //   }
            //   return errors;
            // }}
            onSubmit={(values) => {
              this.sendMessage(values);
            }}
          >
            {({ isSubmitting }) => (
              <Form>
                <Container>
                  {/* <Row>
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <Field
                        type="name"
                        name="name"
                        placeholder="Name"
                      />
                      <ErrorMessage name="Name" component="div" />
                      <Field
                        type="text"
                        name="phone"
                        placeholder="Phone Number"
                      />
                      <ErrorMessage name="phone" component="div" />
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <Field
                        type="email"
                        name="email"
                        placeholder="Email Address"
                      />
                      <ErrorMessage name="email" component="div" />
                      <Field
                        type="text"
                        name="mood"
                        placeholder="What is your mood?"
                      />
                      <ErrorMessage name="mood" component="div" />
                    </Col>
                  </Row> */}
                  <Row>
                    <Col
                      xs={12}
                      md={12}
                      sm={12}
                      lg={12}
                      className={'no-padding'}
                    >
                      <Field
                        type="textarea"
                        name="message"
                        placeholder="Your Message"
                        component="textarea"
                        style={{ minHeight: '200px' }}
                      />
                      <ErrorMessage name="message" component="div" />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={12}
                      md={12}
                      sm={12}
                      lg={12}
                      className={'no-padding'}
                    >
                      <button
                        className="contact-submit"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        Send Message!
                      </button>
                    </Col>
                  </Row>
                </Container>
              </Form>
            )}
          </Formik>
          <style
            dangerouslySetInnerHTML={{
              __html: '.nav-signup { display: none }',
            }}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(ContactUsForm);
